import { render, staticRenderFns } from "./prodc.vue?vue&type=template&id=8bfeccea&scoped=true&"
import script from "./prodc.vue?vue&type=script&lang=js&"
export * from "./prodc.vue?vue&type=script&lang=js&"
import style0 from "./prodc.vue?vue&type=style&index=0&id=8bfeccea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfeccea",
  null
  
)

export default component.exports